import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import PropTypes from 'prop-types';
import React from 'react';

function CustomShortcuts(props) {
  const { shortcutItems, selectedShortcutId, handleShortcutSelect, customLabel } = props;

  // Add Custom option to the list
  const allItems = [...shortcutItems, { id: 'CUSTOM', label: customLabel ?? 'Custom' }];

  return (
    <Box
      sx={{
        gridColumn: 1,
        gridRow: 2,
        borderRight: '1px solid',
        borderColor: 'border.light',
      }}
    >
      <List dense>
        {allItems.map((item) => (
          <ListItem key={item.id} disablePadding>
            <ListItemButton
              selected={selectedShortcutId === item.id}
              onClick={() => handleShortcutSelect(item.id)}
              sx={{
                borderRadius: '8px',
                '&.Mui-selected': {
                  color: 'primary.main',
                },
              }}
            >
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  variant: 'bodyRegular',
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

CustomShortcuts.propTypes = {
  shortcutItems: PropTypes.array.isRequired,
  selectedShortcutId: PropTypes.string,
  handleShortcutSelect: PropTypes.func.isRequired,
  customLabel: PropTypes.string,
};

export default CustomShortcuts;
